import React from 'react';

import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import HipchatChevronUpIcon from '@atlaskit/icon/glyph/hipchat/chevron-up';

import { PurpleButtonStyled } from '@qality/common-components/src/atoms/PurpleButton';
import { WhiteSubtleButtonStyled } from '@qality/common-components/src/atoms/WhiteSubtleButton';

import { CardAction } from '../CardAction';
import { IconWrapper } from '../HelpPanel.styled';
import {
  ButtonWrapper,
  Card,
  CardButtons,
  CardContentWrapper,
  CardHeader,
} from './HelpPanelCard.styled';

export interface HelpPanelCardProps {
  name: string;
  content: React.ReactNode;
  mainAction?: CardAction;
  secondaryAction?: CardAction;
  onActionClick: (link?: string, callback?: () => void) => void;
  onExpand: () => void;
  onCollapse: () => void;
  isOpen: boolean;
}

export const HelpPanelCardView: React.FC<HelpPanelCardProps> = ({
  name,
  content,
  mainAction,
  secondaryAction,
  onActionClick,
  onExpand,
  onCollapse,
  isOpen,
}: HelpPanelCardProps) => {
  return (
    <Card>
      <CardHeader>
        <h5>{name}</h5>
        {isOpen ? (
          <IconWrapper onClick={onCollapse}>
            <HipchatChevronUpIcon label='chevronUpIcon' />
          </IconWrapper>
        ) : (
          <IconWrapper onClick={onExpand}>
            <HipchatChevronDownIcon label='chevronDownIcon' />
          </IconWrapper>
        )}
      </CardHeader>
      {isOpen && (
        <CardContentWrapper>
          {content}
          <CardButtons>
            {mainAction && (
              <ButtonWrapper>
                <PurpleButtonStyled
                  onClick={() =>
                    onActionClick(mainAction.link, mainAction.callback)
                  }
                >
                  {mainAction.label}
                </PurpleButtonStyled>
              </ButtonWrapper>
            )}
            {secondaryAction && (
              <WhiteSubtleButtonStyled
                appearance='subtle'
                onClick={() =>
                  onActionClick(secondaryAction.link, secondaryAction.callback)
                }
              >
                {secondaryAction.label}
              </WhiteSubtleButtonStyled>
            )}
          </CardButtons>
        </CardContentWrapper>
      )}
    </Card>
  );
};
